define('views/shared/browserwarning/browserwarning',["backbone",
        "text!views/shared/browserwarning/browserwarning.html",
        "views/_base/baseview"
], function (Backbone, Template, BaseView) {
    "use strict";

    return BaseView.extend({
        template: _.template(Template),
        initialize: function (options) {},
        render: function () {
            this.$el.html(this.template());
            return this;
        },
        close: function () {}
    });
});
